<!-- <div class="spinner-border text-primary" role="status" id="loading">
    <span class="sr-only">Loading...</span>
  </div> -->
<div class="loading" id="loading">
  <div class="animation6">
    <div class="shape shape-1"></div>
    <div class="shape shape-2"></div>
    <div class="shape shape-3"></div>
    <div class="shape shape-4"></div>
  </div>
</div>
